import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import http from "services/httpService";
import {
  ContentRowGrey,
  HeaderRow,
  InputDiv,
  SearchfilterDiv,
  TableWrapper,
  Download,
  EmpMisSearchFilterDiv,
} from "components/core/BaseTable/styles";
import { Chip, Icons, LoaderDots, OverlayLoader, Ptag } from "components/core";
import DownloadIcon from "assets/images/downloadcsv.png";
import { useLocation, useNavigate } from "react-router";
import { DownloadLink } from "pages/CareDashboard/styles";
import { capitalizeSecondLetter, formatCtcValue, formatToRupees } from "utlis/utils";
// import "./styles.css";
import { MessageDiv } from "pages/CareDashboard/CareDashboardList";
import Lottie from "react-lottie";
import emptyFile from "assets/lottie/empty_file.json";
import { FlexColumn } from "components/core/Cards/styles";
import Filter from "./Filter";
import { FLEX_PRODUCTS } from "pages/FlexSetup/constants";
import { Box } from "@mui/material";
import GlassWrapper from "components/GlassWrapper";
// import employeeMisTableBg from "../../../assets/svgs2026/benefitsBackgroundSvg.2e98e7b1.svg"
import tableHeaderBgImg from "../../../assets/images2026/tableHeaderBgImg.png"
import planSumSubImg from "../../../assets/images2026/Frame.png";


const EmployeeMIS = () => {
  const timerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [overallData, setOverallData] = useState();
  const [activeFilters, setActiveFilters] = useState(new Set());
  const [searchString, setSearchString] = useState("");
  const [columns, setColumns] = useState([]);
  const [tabularLoading, setTabularLoading] = useState(true);
  const [paginationData, setPaginationData] = useState(null)
  const [contentLoading, setContentLoading] = useState(true)
  const location = useLocation()
  const didMountRef = useRef(false);
  const defaultOffset = 20;
  const params = new URLSearchParams(location.search);

  function fixedHeaderContent() {
    return (
      <TableRow style={{ 
          // backgroundImage: `url(${tableHeaderBgImg})`,
          // backgroundSize: "cover",
          // backgroundPosition: "center",
          // backgroundRepeat: "no-repeat",
          backgroundColor: "#25183e",
       }}
       >
        {columns.map((column, index) => (
          <TableCell
            key={index}
            variant="head"
            align="left"
            style={{ width: column.width }}
            sx={{
              ...HeaderRow,
              backgroundColor: "#25183e",
              color: "#ffffff",
              fontFamily: "Montserrat",
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              padding: "18px 28px",
              "&:first-of-type": {
                borderTopLeftRadius: "8px",
              },
              "&:last-of-type": {
                borderTopRightRadius: "8px",
              },
            }}
          >
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    );
  }

  const navigate = useNavigate();
  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    const currentSearch = location.search.startsWith("?")
      ? location.search.slice(1)
      : location.search;

    const nextParams = new URLSearchParams(location.search);
    nextParams.set("start", 1);
    nextParams.set("end", defaultOffset);
    const nextSearch = nextParams.toString();

    timerRef.current = setTimeout(() => {
      if (currentSearch === nextSearch) {
        getModernFlex();
        return;
      }

      navigate({
        pathname: location.pathname,
        search: nextSearch,
      });
    }, 600);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [searchString, location.pathname, navigate]);

  useEffect(() => {
    getModernFlex();
  }, [location.search]);
  

  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message ===
        "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);


  function isActivatedFlexEmployee(status) {
    if (!status || !Array.isArray(status)) {
      return false;
    }
    const show = status.join().includes("ACTIVATED");
    return show;
  }
  const getFlexProductStatus = (status) => {
    let JSX = [];
    
    if (!status || !Array.isArray(status)) {
      return (
        <section
          style={{ gap: "0.6rem", display: "flex", justifyContent: "flex-start" }}
        >
          <span>-</span>
        </section>
      );
    }
 
    status.forEach((value, index) => {
      if (value && typeof value === 'string') {
        if (value.includes("PENDING")) {
          JSX.push(
            <Chip
              background="#F7CB59"
              text={capitalizeSecondLetter(value)}
              className="child-component"
            />
          );
        } else if (value.includes("ACTIVATED")) {
          JSX.push(
            <Chip
              background="#81C14B"
              text={capitalizeSecondLetter(value)}
              className="child-component"
            />
          );
        } else if (value.includes("DELET")) {
          JSX.push(
            <Chip
              background="#FF9446"
              text={capitalizeSecondLetter(value)}
              className="child-component"
            />
          );
        } else if (value.includes("STOPPED")) {
          JSX.push(
            <Chip
              background="#F27576"
              text={capitalizeSecondLetter(value)}
              className="child-component"
            />
          );
        }
      }
    });

    return (
      <section
        style={{ gap: "0.6rem", display: "flex", justifyContent: "flex-start", flexWrap: "wrap" }}
      >
        {JSX.map((el) => el)}
      </section>
    );
  };

  function stringValueHandler(value, columnLabel, headersWithPossibleStringNumValues) {
    if (headersWithPossibleStringNumValues.includes(columnLabel)) {
      // check if value can be treated as a number
      if (!isNaN(value) && value !== null && value !== "") {
        return formatToRupees(value);
      }
      // if not a number (big string description), return as is
      return value;
    }
    if (typeof value === "string" && value.includes(".")) {
      return formatToRupees(value.split(".")[0])
    } else {
      return formatToRupees(value);
    }
  }

  function jsxRow(column, index, row) {
    let JSX;
    const columnWidth = column.width + "px";
    const headersWithPossibleStringNumValues = ["GMC Sum Insured", "GTL Sum Insured"]
    switch (column.label) {
      case "E-Card":
        JSX = (
          <TableCell
            align="left"
            style={{
              width: columnWidth,
            }}
            sx={{ ...ContentRowGrey, padding: "16px 28px" }}
            key={index}
          >
            {isActivatedFlexEmployee(row.Status) ? (
              <DownloadLink onClick={() => navigateToEcardPreview(row)}>
                View
              </DownloadLink>
            ) : (
              <Ptag
                textAlign="left"
                fontSize="14px"
                lineHeight={1.3}
                fontWeight="500"
              >
                -
              </Ptag>
            )}
          </TableCell>
        );
        break;
      case "Status":
        JSX = (
          <TableCell
            sx={{ ...ContentRowGrey, padding: "16px 28px" }}
            style={{
              width: columnWidth,
            }}
          >
            {getFlexProductStatus(row.Status)}
          </TableCell>
        );
        break;
      default: {
        const targetLabel = "Sum Insured";
        const isSumInsuredColumn = column.label.includes(targetLabel);

        let formattedValue;

        if (isSumInsuredColumn) {
          const cellValue = row[column.label]
            ? row[column.label].toString()
            : "";

          if (cellValue) {
            // formattedValue = formatToRupees(cellValue);
            formattedValue = stringValueHandler(cellValue, column.label, headersWithPossibleStringNumValues)
          } else {
            formattedValue = "-";
          }
        } else {
          formattedValue = row[column.label] || "-";
        }
        JSX = (
          <TableCell
            align="left"
            sx={{ ...ContentRowGrey, padding: "16px 28px" }}
            key={index}
          >
            {formattedValue || "_"}
          </TableCell>
        );
        break;
      }
    }
    return JSX;
  }

  function rowContent(_index, row) {
    let JSX;
    try {
      if (!columns || !Array.isArray(columns) || !row) {
        return <></>;
      }
      JSX = <>{columns.map((column, index) => jsxRow(column, index, row))}</>;
    } catch (error) {
      console.error("Error in rowContent:", error);
      return <></>;
    }
    return JSX;
  }

  const navigateToEcardPreview = (row) => {
    navigate(`/v1/employee-mis/e-cards/${row["System Employee Id"]}`);
  };
  const getModernFlex = async (filtersArr = activeFilters) => {
    setContentLoading(true)
    const pageStarting = params.get('start') || 1;
    const pageEnd = params.get('end') || defaultOffset;
    const filtersFromUrl = params.get("filters");
    let selectedFilters = filtersArr;

    if (filtersFromUrl) {
      try {
        selectedFilters = new Set(JSON.parse(filtersFromUrl));
      } catch (error) {
        selectedFilters = filtersArr;
      }
    }

    let localToken = Number(pageStarting);
    let error = false;
    // while (localToken !== 0 && localToken !== null && error === false) {
      const payload = {
        token: Number(localToken),
        offset: Number(pageEnd),
      };
      if (searchString) {
        payload.search_string = searchString;
      }
      if (selectedFilters && selectedFilters.size > 0) {
        const status = [...selectedFilters].filter(
          (item) => item === "Activated" || item === "Stopped" || item === "Activation Pending" || item === "Deletion_Initiated"
        );
        const products = [...selectedFilters].filter(
          (item) => item !== "Activated" && item !== "Stopped" && item !== "Activation Pending" && item !== "Deletion_Initiated"
        );

        if (status.length > 0) {
          payload.status_filter = status.map((name) => name.toUpperCase());
        }
        if (products.length > 0) {
          payload.userplan_filter = products.map(
            (name) =>
              filters.productFilters.find((product) => product.name === name)
                .userplan
          );
        }

        console.log({ status, products });
      }
      try {
        let { data } = await http.get(
          "business/get_employee_detail_for_group_products/",
          {
            params: payload,
          }
        );

        if (data?.mis_employee_data) {
          data.mis_employee_data = data.mis_employee_data.map((employee) => {
            const gpa = employee["GPA Sum Insured"];
            const gtl = employee["GTL Sum Insured"];

            if (
              typeof gpa === "string" &&
              gpa.toLowerCase().includes("x of ctc")
            ) {
              employee["GPA Sum Insured"] = formatCtcValue(gpa);
            }

            if (
              typeof gtl === "string" &&
              gtl.toLowerCase().includes("x of ctc")
            ) {
              employee["GTL Sum Insured"] = formatCtcValue(gtl);
            }

            return employee;
          });
        }
        
        if(data) {
          setPaginationData(data)
        }
        if ((selectedFilters && selectedFilters.size > 0) || searchString) {
          setOverallData(data.mis_employee_data || []);
        } else if (data) {
          setOverallData([...data.mis_employee_data]);
        } else {
          setOverallData([]);
        }

        if (localToken >= 1) {
          const status_width = (data.headers_data.length - 4) / 2;
          const col_name = data.headers_data;
          const newColm = col_name.map((val, index) => {
            let local_width = 160;
            if (val == "Status") {
              local_width = status_width * 160;
            }
            return { width: local_width, label: val };
          });
          setColumns(newColm);
        }
        localToken = data.end_index;
        // setOverallData((prevArray) => [...prevArray, data.mis_employee_data]);
      } catch (e) {
        error = true;
        console.log(e);
      } finally {
        if (!filters && !searchString) setIsLoading(false);
        setContentLoading(false)
      }
    // }
    setTabularLoading(false);
  };

  const downloadExcel = async () => {
    let { data } = await http.post(
      "business/download_mis_or_data_collection/",
      {},
      { responseType: "blob" }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "employee_data.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  };

  const handleSearchChange = (e) => {
    setOverallData([]);
    const newSearchString = e.target.value;
    setSearchString(newSearchString);

    // if (timerRef.current) {
    //   clearTimeout(timerRef.current);
    // }

    // Set a new timer to call the API after 2 seconds
    // timerRef.current = setTimeout(async () => {
    //   setOverallData([]);
    //   console.log(" 3")
    //   await getModernFlex(newSearchString);
    // }, 500);
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: emptyFile,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const filters = useMemo(() => {
    const productFilters = [];
    const products = JSON.parse(localStorage.getItem("products"));
    Object.keys(products).forEach((key) => {
      productFilters.push({
        name: FLEX_PRODUCTS?.filter((val) => val?.value === key)[0]?.display_name,
        value: key,
        userplan: products[key].userplan,
      });
    });
    console.log({ products });
    const filterArray = [
      ["By Product", productFilters.map(({ name }) => name)],
      ["By Status", ["Activated", "Stopped", "Activation Pending", "Deletion_Initiated"]],
    ];
    return { filterArray, productFilters };
  }, []);

  const filterHandler = (filter) => {
    const selectedFilters = new Set(filter);
    setActiveFilters(selectedFilters);

    const params = new URLSearchParams(location.search);
    params.set("start", 1);
    params.set("end", defaultOffset);
    if (selectedFilters.size > 0) {
      params.set("filters", JSON.stringify(Array.from(selectedFilters)));
    } else {
      params.delete("filters");
    }
    navigate({
      pathname: location.pathname,
      search: params.toString(),
    });
  }

  const nextPageHandler = () => {
    const params = new URLSearchParams(location.search);

    if(paginationData.token) {
      params.set('start', paginationData.token);
      params.set('end', defaultOffset);
      navigate({
        pathname: location.pathname,
        search: params.toString(),
      });
    }
  };

  const prevPageHandler = () => {
    const params = new URLSearchParams(location.search);
    params.set('start', Number(params.get('start')) - 1);
    params.set('end', defaultOffset);
    navigate({
      pathname: location.pathname,
      search: params.toString(),
    });
  }

  const pageNumberHandler = () => {
    let startingPage = 1
    let endPage = paginationData.total_records

    if(params.get('start')) {
      startingPage = params.get('start')
    }
    return [startingPage, endPage]
  }

  const isValidPrevPageNumber = () => {
    let pageStartingNum = params.get('start') || 1;
    if(pageStartingNum > 1) {
      return true
    } 
    return false
  }

  const isValidNextPageNumber = () => {
    if(paginationData.token) {
      return true
    } 
    return false
  }

  const shouldPaginate = Number(paginationData?.total_records || 0) > defaultOffset;

  if (tabularLoading) {
    return <OverlayLoader />;
  }

  return (
    <>
      {false ? (
        <div
          style={{ display: "flex", justifyContent: "center", padding: "44px" }}
        >
          <LoaderDots />
        </div>
      ) : (
        <>
          {true ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  // borderRadius: "6px",
                  // backgroundColor: "#E5E2EF",
                  marginBottom: "24px",
                }}
              >
                  <EmpMisSearchFilterDiv>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        gap: "16px"
                      }}
                    >
                      {/* <InputDiv style={{ maxWidth: "100%" }}> */}
                      <div>
                        <input
                          value={searchString}
                          onChange={handleSearchChange}
                          className="custom-input-elevated"
                          type="text"
                          placeholder="Search"
                        />
                      </div>

                      {/* </InputDiv> */}
                      <div
                        style={{
                          padding: "6px 0px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Filter
                          filters={filters.filterArray}
                          onChange={filterHandler}
                          text="Filters"
                          category
                          showFilterNo={false}
                        />
                        {/* {getFilters("products").length > 0 && (
                        <FilterCard
                          title="Products"
                          filters={getFilters("products")}
                        />
                      )}
                      {getFilters().length > 0 && (
                        <FilterCard title="Status" filters={getFilters()} />
                      )} */}
                      </div>
                    </Box>
                    <Download
                      onClick={downloadExcel}
                      style={{
                        // width: "320px",
                        whiteSpace: "nowrap",
                        paddingRight: "20px",
                        display: "flex",
                        gap: "15px"
                      }}
                    >
                      <span className="mis-download-div-text">
                        Download Employee Data
                      </span>
                      <GlassWrapper className="glass-xl">
                        <img
                          src={DownloadIcon}
                          width="18px"
                          height="18px"
                          style={{ margin: "4px", padding: "1px" }}
                        />
                      </GlassWrapper>
                    </Download>
                  </EmpMisSearchFilterDiv>

                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {/* <Filter
                      filters={filters.filterArray}
                      onChange={filterHandler}
                      text="Filters"
                      category
                      showFilterNo={false}
                    /> */}
                  </Box>
                </Box>
              </Box>
                <Box>
                  <TableWrapper
                    style={{
                      position: "relative",
                      height: "auto",
                      overflow: "hidden",
                      backgroundColor: "#ffffff", // White background for wrapper
                    }}
                  >
                    <TableContainer
                      sx={{
                        overflowX: "auto",
                        overflowY: "visible",
                        position: "relative", // Anchors sticky overlay to TableContainer
                        backgroundColor: "#ffffff", // Guarantees white table background
                      }}
                    >
                      <Table sx={MaterialTableNew}>
                        <TableHead>{fixedHeaderContent()}</TableHead>

                        {/* --- DATA ROWS OR EMPTY SPACER --- */}
                        {overallData && overallData.length === 0 ? (
                          <TableBody>
                            <TableRow>
                              <TableCell
                                colSpan={columns?.length}
                                sx={{
                                  border: 0,
                                  padding: 0,
                                  background: "#ffffff", // White fill inside TableBody
                                }}
                              />
                            </TableRow>
                          </TableBody>
                        ) : (
                          <TableBody>
                            {(overallData || []).map((row, index) => (
                              <TableRow key={row["System Employee Id"] || index}>
                                {rowContent(index, row)}
                              </TableRow>
                            ))}
                          </TableBody>
                        )}
                      </Table>

                      {/* --- SCREEN-VIEWPORT CENTERED NO DATA TEXT (MOVED INSIDE TableContainer) --- */}
                      {overallData && overallData.length === 0 && (
                        <Box
                          sx={{
                            position: "sticky",
                            left: 0,
                            right: 0,
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "24px 0",
                            pointerEvents: "none",
                            backgroundColor: "#ffffff", // Explicit white background
                          }}
                        >
                          <span className="table-nodata-text-css">No Data Found</span>
                        </Box>
                      )}
                    </TableContainer>
                  </TableWrapper>
                  {shouldPaginate && <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "18px" }}>
                    <Ptag fontWeigh="500" fontFamily="Montserrat" color="rgba(0, 0, 0, 1)" fontSize="14px" lineHeight="20px">
                      {"Page"} {`${pageNumberHandler()[0]} of ${Math.ceil(Number(pageNumberHandler()[1]) / defaultOffset)}`}
                    </Ptag>
                    <Box sx={{ display: "flex", gap: "12px" }}>
                      <button
                        // style={{ opacity: isValidPrevPageNumber() ? 1 : 0.4 }}
                        style={{ opacity: contentLoading ? 0.4 : (isValidPrevPageNumber() ? 1 : 0.4) }}
                        disabled={!isValidPrevPageNumber() || contentLoading}
                        className="pagination-button-css pagination-prev-button-css"
                        onClick={prevPageHandler}>Previous</button>
                      <button
                        // style={{ opacity: isValidNextPageNumber() ? 1 : 0.4 }}
                        style={{ opacity: contentLoading ? 0.4 : (isValidNextPageNumber() ? 1 : 0.4) }}
                        disabled={!isValidNextPageNumber() || contentLoading}
                        className="pagination-button-css pagination-next-button-css"
                        onClick={nextPageHandler}>Next</button>
                    </Box>
                  </Box>}
                </Box>
            </>
          ) : (
            <MessageDiv>
              <FlexColumn>
                <Lottie
                  options={defaultOptions}
                  height={120}
                  width={120}
                  style={{ opacity: "1" }}
                  isClickToPauseDisabled
                />
                <Ptag fontSize="18px" fontWeight="600" lineHeight="20">
                  Employee Data Unavailable
                </Ptag>
              </FlexColumn>
            </MessageDiv>
          )}
        </>
      )}
    </>
  );
};

export default EmployeeMIS;

export const MaterialTableNew = {
  tableLayout: "fixed",
  border: "none",
  borderCollapse: "separate",
  "*": {
    fontSize: "14px !important",
  },
};
